import React, { Component } from 'react'
import { connect } from "react-redux";
import axios from 'axios';
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import { NotificationManager } from 'react-notifications';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Selectsearch from "react-select";
import {
   FormGroup,
   Label,
} from 'reactstrap';
import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
   allRoles,
   allMenus,
   addMenu,
   editMenu,
   statusMenu,
   deleteMenu,
   allFeatures,
   editFeature,
   statusFeature,
   deleteFeature,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

function TabContainer({ children }) {
   return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
         {children}
      </Typography>
   );
}

class Menuaccess extends Component {

   constructor(props) {

      super(props);
      this.state = {
         activeIndex: 0,
         name: '',
         adddiv: false,
         editdiv: false,
         eid: '',
         edname: '',
         eddisplay: '',
         chkbox: false,
         addchkbox: false,
         academylist: [],
         programname: '',
         pgadddiv: false,
         pgeditdiv: false,
         featureid: '',
         featurename: '',
         featuredisplay: '',
         featroles: [],
         menuroles: [],


      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this);
      this.deleteMenu = this.deleteMenu.bind(this);
      this.editMenu = this.editMenu.bind(this);
      this.statusMenu = this.statusMenu.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);

      this.addFeatureSubmit = this.addFeatureSubmit.bind(this);
      this.editFeature = this.editFeature.bind(this);
      this.editFeatureSubmit = this.editFeatureSubmit.bind(this);


   }

   UNSAFE_componentWillMount() {
      this.props.allRoles();
      this.props.allMenus();
      this.props.allFeatures();
   }


   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addMenu(this.state.name).then((data) => {

         if (data.status == 1) {
            this.setState({
               name: ''
            });
         }
      });

   }

   deleteMenu(academyid) {
      if (window.confirm('Are you sure to delete this Menu?')) {
         this.props.deleteMenu(academyid);
      }
   }

   editMenu(rawdata) {
      console.log(rawdata, "rawdataef")
      const { rolelists } = this.props;
      const featureRoles = rawdata.xm_menuRole.split(',');

      console.log('Role Lists:', rolelists);

      const selectedRoles = rolelists
         .filter(role => featureRoles.includes(role.xrlID.toString()))
         .map(role => ({ label: role.xrl_roleName, value: role.xrlID }));

      console.log('Selected Roles:', selectedRoles);

      if (selectedRoles.length === 0) {
         console.error('No matching roles found in rolelists.');
      }

      this.setState({
         eid: rawdata.xmID,
         edname: rawdata.xm_menuName,
         menuroles: [rawdata.xm_menuRole],
         eddisplay: rawdata.xm_menuDisplay,
         adddiv: false,
         editdiv: true,
         menuroles: selectedRoles
      });
   }


   editHandleSubmit(event) {
      event.preventDefault();
      var menuRoles = this.state.menuroles.map(role => role.value); 
      var commaSep = [...menuRoles].join(',');
      this.props.editMenu(this.state.edname, commaSep, this.state.eddisplay, this.state.eid).then((data) => {
      });

   }

   statusMenu(id, status) {
      this.props.statusMenu(id, status);
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         editdiv: false,
         pgadddiv: false,
         pgeditdiv: false,
      });
   }

   handleChange(value) {
      this.setState({ activeIndex: value });
   }

   addFeatureSubmit(event) {
      event.preventDefault();

      var payload = {
         "name": this.state.programname
      }
      axios.post(AppConfig.apiurl + '/api/addprogram', payload, { headers: AuthHeader.header })
         .then(response => {
            if (response.status == 200) {
               var resdata = response.data;
               if (resdata.status === 1) {
                  NotificationManager.success(resdata.message);
                  this.getAllProgram();
                  this.setState({ programname: '' });
               } else {
                  NotificationManager.error(resdata.message);
               }
            } else {
               NotificationManager.error('Program not added');
            }

         })
         .catch(error => {
            NotificationManager.error(error);
         });
   }

   editFeature(rawdata) {
      const { rolelists } = this.props;
      const featureRoles = rawdata.xfs_roleID.split(',');

      console.log('Role Lists:', rolelists);

      const selectedRoles = rolelists
         .filter(role => featureRoles.includes(role.xrlID.toString())) 
         .map(role => ({ label: role.xrl_roleName, value: role.xrlID }));

      console.log('Selected Roles:', selectedRoles);

      if (selectedRoles.length === 0) {
         console.error('No matching roles found in rolelists.');
      }

      this.setState({
         featureid: rawdata.xfsID,
         featurename: rawdata.xfs_featureName,
         featuredisplay: rawdata.xfs_display,
         pgadddiv: false,
         pgeditdiv: true,
         featroles: selectedRoles,

      });
   }

   editFeatureSubmit(event) {
      event.preventDefault();
      var id = this.state.featureid;
      var roles = this.state.featroles.map(role => role.value);
      var commaSep = roles.join(',');

      this.props.editFeature(event, commaSep, id);
   }

   statusFeature(id, status) {
      this.props.statusFeature(id, status);
   }

   menuselrole = (selectedRoles) => {
      this.setState({ menuroles: selectedRoles });
    }
    
    selrole = (selectedOptions) => {
      this.setState({ featroles: selectedOptions });
    }

   render() {
      const { match, academylists, featurelists, rolelists, menulists, loading } = this.props;
      const allrole = rolelists.map((stdval) => {
         return {
            label: stdval.xrl_roleName,
            value: stdval.xrlID
         }
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Menu Access | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.menuaccessheading" />} match={match} />


            <RctCollapsibleCard >
               <Tabs
                  value={this.state.activeIndex}
                  onChange={(e, value) => this.handleChange(value)}
                  variant="fullWidth"
                  textColor="primary"
                  indicatorColor="primary">
                  <Tab label="MENU" />
                  <Tab label="FEATURE" />
               </Tabs>

               {this.state.activeIndex === 0 &&
                  <TabContainer>
                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="Menu List">
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                    <thead>
                                       <tr className="bg-primary text-white">
                                          <th>Sl.No</th>
                                          <th>Menu Name</th>
                                          <th>Feature</th>
                                          <th>Roles</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {menulists.map((acdyval, idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td>{acdyval.xm_menuName}</td>
                                             <td>{acdyval.xfs_featureName}</td>
                                             <td>{acdyval.rolename}</td>
                                             <td>
                                                {acdyval.xm_menuStatus == 1 ? (
                                                   <a herf="" onClick={() => this.statusMenu(acdyval.xmID, 0)}><span className="badge badge-info" >Active</span></a>
                                                ) : (
                                                   <a herf="" onClick={() => this.statusMenu(acdyval.xmID, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                                )}
                                                <IconButton className="text-info" aria-label="edit" onClick={() => this.editMenu(acdyval)}><EditOutlinedIcon/></IconButton>
                                             </td>
                                          </tr>
                                       ))}

                                    </tbody>
                                 </Table>
                              </div>
                           </RctCollapsibleCard>
                        </div>
                        {this.state.adddiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Add Menu">
                                 <form autoComplete="off" onSubmit={(e) => this.addHandleSubmit(e)}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.name} onChange={evt => this.setState({ name: evt.target.value })} />
                                          </div>

                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }

                        {this.state.editdiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Edit Menu">
                                 <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.edname} onChange={evt => this.setState({ edname: evt.target.value })} />
                                          </div>
                                          <div className="col-sm-12 col-lg-12">
                                             <Label for="Select">Role *</Label>
                                             <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch
                                                   id="featurerole"
                                                   name="featurerole"
                                                   isMulti
                                                   placeholder="Select..."
                                                   options={allrole}
                                                   rules={{ required: 'Please select role' }}
                                                   value={this.state.menuroles} 
                                                   onChange={this.menuselrole}
                                                   required
                                                />

                                             </FormGroup>
                                          </div>
                                          <div className="form-group">
                                             <TextField id="display" fullWidth label="display" required value={this.state.eddisplay} onChange={evt => this.setState({ eddisplay: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                             <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }
                     </div>

                  </TabContainer>}
               {this.state.activeIndex === 1 &&
                  <TabContainer>

                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="Feature List">
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                    <thead>
                                       <tr className="bg-primary text-white">
                                          <th>Sl.No</th>
                                          <th>Name</th>
                                          <th>Roles</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {featurelists.map((featval, idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td>{featval.xfs_featureName}</td>
                                             <td>{featval.rolename}</td>
                                             <td>
                                                {featval.xfs_status == 1 ? (
                                                   <a herf="" onClick={() => this.statusFeature(featval.xfsID, 0)}><span className="badge badge-info" >Active</span></a>
                                                ) : (
                                                   <a herf="" onClick={() => this.statusFeature(featval.xfsID, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                                )}
                                                <IconButton className="text-primary" aria-label="edit" onClick={() => this.editFeature(featval)}><EditOutlinedIcon/></IconButton>
                                             </td>
                                          </tr>
                                       ))}

                                    </tbody>
                                 </Table>
                              </div>
                           </RctCollapsibleCard>
                        </div>

                        {this.state.pgadddiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Add Program">
                                 <form autoComplete="off" onSubmit={(e) => this.addFeatureSubmit(e)}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.programname} onChange={evt => this.setState({ programname: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }

                        {this.state.pgeditdiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Edit Feature">
                                 <form autoComplete="off" onSubmit={this.editFeatureSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.featurename} onChange={evt => this.setState({ featurename: evt.target.value })} />
                                          </div>
                                          <div className="col-sm-12 col-lg-12">
                                             <Label for="Select">Role *</Label>
                                             <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch
                                                   id="featurerole"
                                                   name="featurerole"
                                                   isMulti
                                                   placeholder="Select..."
                                                   options={allrole}
                                                   rules={{ required: 'Please select role' }}
                                                   value={this.state.featroles}
                                                   onChange={this.selrole}
                                                   required
                                                />
                                             </FormGroup>
                                          </div>
                                          <div className="form-group">
                                             <TextField id="display" fullWidth label="display" required value={this.state.featuredisplay} onChange={evt => this.setState({ featuredisplay: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                             <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }

                     </div>


                  </TabContainer>}

            </RctCollapsibleCard>


         </div>
      )
   }
}

const mapStateToProps = ({ academy, menuaccess, role }) => {
   const { academylists, loading } = academy;
   const { featurelists, menulists } = menuaccess;
   const { rolelists } = role;
   return { academylists, featurelists, rolelists, menulists, loading };
}

export default connect(mapStateToProps, {
   allRoles,
   allMenus,
   addMenu,
   editMenu,
   statusMenu,
   deleteMenu,
   allFeatures,
   editFeature,
   statusFeature,
   deleteFeature,
})(Menuaccess); 